const userStorage = {};
Object.defineProperties(userStorage, {
  token: {
    enumerable: true,
    get() {
      const cookies = document.cookie.split(/;\s*/g);
      let cookieItem;
      while ((cookieItem = cookies.shift())) {
        if (cookieItem.indexOf('token') === 0) {
          return cookieItem.split('=')[1];
        }
      }
      return null;
    },
    set(val) {
      document.cookie = `token=${val};path=/`;
    }
  },
  userInfo: {
    enumerable: true,
    get() {
      if (localStorage.userInfo !== undefined) {
        return JSON.parse(localStorage.userInfo);
      } else {
        return {};
      }
    },
    set(val) {
      localStorage.userInfo = JSON.stringify(val);
    }
  },
  clear: {
    value() {
      const temp = new Date();
      temp.setTime(temp.getTime() - 100);
      document.cookie = `token='';expires=${temp.toGMTString()};path=/`;
      localStorage.removeItem('userInfo');
    }
  }
});

export default userStorage;
